export function getLabel(priorities) {
  if (priorities.length === 0) {
    return 'Priority'
  } else if (priorities.length === 1) {
    return priorities.map(priority => priority.text)
  } else {
    return `${priorities.length} priorities`
  }
}
